import { render } from "./skeletonDrawing.vue?vue&type=template&id=4116c151&scoped=true"
import script from "./skeletonDrawing.vue?vue&type=script&lang=js"
export * from "./skeletonDrawing.vue?vue&type=script&lang=js"

import "./skeletonDrawing.vue?vue&type=style&index=0&id=4116c151&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4116c151"]])

export default __exports__